<template>
  <div class="main-content">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      class="news-item"
      v-for="item in list"
      :key="item.id"
    >
      <div class="news-content">
        <div>
          <div class="img-holder">
            <ImageContainer
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
              class="img"
            />
            <div class="cat-wrapper">
              <div class="cat-meta">{{ item.sub_category.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="meta-wrapper">
        <div class="title limited-text" style="--snup: 4">
          {{ item.title }}
        </div>
        <div class="date-wrapper">
          <span class="date">{{ handleDate(item.pub_date) }},</span>
          <span class="date" style="padding-left: 0.44em">{{
            handleTime(item.pub_date)
          }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { useFormatter } from "../utils/formatter";
import ImageContainer from "../components/ImageContainer";
export default {
  name: "AdditionalBar",
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
img {
  background-color: lightgray;
}
.main-content {
  position: relative;
  width: var(--main-wrapper-width);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 5em;
  margin: 0 auto;

  .news-item {
    width: 30%;
    height: auto;
    position: relative;
    padding-bottom: 4.375rem;
    margin: 0 1rem;

    &:hover {
      img {
        transform: scale(1.14);
      }
    }

    .news-content {
      width: 100%;
      padding-bottom: 0.75em;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .img-holder {
      width: 100%;
      border-radius: 4px;
      padding-top: 59.09%; /* 22:13 Aspect Ratio */
      position: relative;
      overflow: hidden;

      .img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 4px;
        transition: all 0.4s ease;
      }

      .cat-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        background-color: var(--background-color);
        height: 1.6rem;
        font-family: Open Sans;
        .cat-meta {
          display: flex;
          align-items: center;
          justify-content: center;
          &:first-child {
            font-weight: 600;
            text-transform: uppercase;
            padding: 0 0.375rem;
          }
        }
      }
    }
    .title {
      font-family: Alice;
      font-size: 1.25em;
      font-weight: 500;
      line-height: 1.5rem;
      // padding-top: 0.625rem;
    }
    .date-wrapper {
      font-weight: 300;
      font-size: 0.875em;
      padding-top: 0.75em;
      opacity: 0.8;
      font-family: Open Sans;
    }
  }
}
@media screen and (max-width: 992px) {
  .main-content {
    .news-item {
      width: 30%;
      padding-bottom: 2.75em;
      margin: 0;

      .title {
        font-size: 1em;
        padding-top: 0;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .main-content {
    .news-item {
      width: 47%;
    }

    .title {
      padding-top: 0;
    }
  }
}

@media screen and (max-width: 430px) {
  .main-content {
    display: block;
    width: 90%;
    .news-item {
      display: flex;
      width: 100%;
      padding-bottom: 2rem;

      .news-content {
        width: 50%;
        padding-bottom: 0;
        .img-holder {
          width: 100%;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
            transition: all 0.4s ease;
          }
          .cat-wrapper {
            font-size: 10px;
            height: 1.1rem;
          }
        }
      }
      .meta-wrapper {
        max-width: 50%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        padding-left: 0.8rem;

        .title {
          font-family: Alice;
          font-size: 0.9em;
          font-weight: 500;
          line-height: 1.5em;
        }
        .date-wrapper {
          font-weight: 300;
          font-size: 0.675em;
          opacity: 0.8;
          font-family: Open Sans;
        }
      }
    }
  }
}
</style>
